export interface NavItem {
  to: string
  label: string
  icon: string
}

export interface NavGroup {
  label: string
  items: NavItem[]
}

export const NAV: NavGroup[] = [
  {
    label: 'Overview',
    items: [
      { to: '/', label: 'Dashboard', icon: '\uD83D\uDCCA' },
      { to: '/scanner', label: 'Opportunity Scanner', icon: '\uD83D\uDD0E' },
      { to: '/watchlist', label: 'Watchlist', icon: '\uD83D\uDC41' },
    ],
  },
  {
    label: 'Analyze',
    items: [
      { to: '/stocks', label: 'Stock Analyzer', icon: '\uD83D\uDCC8' },
      { to: '/markets', label: 'Prediction Markets', icon: '\uD83C\uDFB2' },
      { to: '/odds', label: 'Betting Odds', icon: '\uD83C\uDFDF' },
      { to: '/model', label: 'Model Lab', icon: '\uD83E\uDDEA' },
    ],
  },
  {
    label: 'Tools',
    items: [
      { to: '/backtest', label: 'Backtest', icon: '\uD83D\uDD01' },
      { to: '/tools/odds', label: 'Odds Converter', icon: '\uD83D\uDD04' },
      { to: '/tools/ev', label: 'EV Calculator', icon: '\uD83E\uDDEE' },
      { to: '/tools/sizing', label: 'Position Sizing', icon: '\uD83D\uDCD0' },
    ],
  },
  {
    label: 'Evaluate',
    items: [
      { to: '/evaluation', label: 'Strategy Evaluation', icon: '\uD83E\uDDEC' },
      { to: '/strategies', label: 'Strategy Lab', icon: '\uD83C\uDFC6' },
      { to: '/calibration', label: 'Calibration & Drift', icon: '\uD83C\uDFAF' },
    ],
  },
  {
    label: 'Manage',
    items: [
      { to: '/risk', label: 'Risk Manager', icon: '\uD83D\uDEE1' },
      { to: '/journal', label: 'Journal', icon: '\uD83D\uDCDD' },
      { to: '/import', label: 'Data Import', icon: '\uD83D\uDCE5' },
    ],
  },
  {
    label: 'System',
    items: [
      { to: '/legal', label: 'Legal & Safety', icon: '\u2696' },
      { to: '/settings', label: 'Settings', icon: '\u2699' },
    ],
  },
]
